/* eslint-disable @typescript-eslint/no-explicit-any */
import { Logger } from 'loglevel';

export class ModuleLogger {
  constructor(private childLogger: Logger, private messagePrefix: string) { }

  error(...messages: any[]): void {
    this.childLogger.error(...this.addMessagePrefix(...messages));
  }

  warn(...messages: any[]): void {
    this.childLogger.warn(...this.addMessagePrefix(...messages));
  }

  debug(...messages: any[]): void {
    this.childLogger.debug(...this.addMessagePrefix(...messages));
  }

  trace(...messages: any[]): void {
    this.childLogger.trace(...this.addMessagePrefix(...messages));
  }

  info(...messages: any[]): void {
    this.childLogger.info(...this.addMessagePrefix(...messages));
  }

  private addMessagePrefix(...unprefixedMessages: string[]): string[] {
    return [this.messagePrefix, ...unprefixedMessages];
  }
}
